import { app } from '../../app';
import { Controller } from './sp-role-type.controller';

app.component('spRoleType', {
    bindings: {
        roleType: '<',
        hideIcon: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-role-type.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-role-type/sp-role-type.component.js